import { render, staticRenderFns } from "./CandidateCard.vue?vue&type=template&id=04e8871b&scoped=true&"
import script from "./CandidateCard.vue?vue&type=script&lang=js&"
export * from "./CandidateCard.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCard.vue?vue&type=style&index=0&id=04e8871b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e8871b",
  null
  
)

export default component.exports